import { ElementRef } from '@angular/core';

export class ErrorList {
    id?: number = 0;
    fieldName: string;
    completFieldName?: string ='';
    errorMsg: string|null;
    fieldRef: ElementRef;
	object?: any;
	clickCallback?: Function;
}
